import { render, staticRenderFns } from "./ChatMessageList.vue?vue&type=template&id=4f520d12&scoped=true"
import script from "./ChatMessageList.vue?vue&type=script&lang=ts"
export * from "./ChatMessageList.vue?vue&type=script&lang=ts"
import style0 from "./ChatMessageList.vue?vue&type=style&index=0&id=4f520d12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f520d12",
  null
  
)

export default component.exports